<template>
    <transition name="fade">
        <div id="del_popup" v-if="isVisible" @click.self="close">
            <div class="welcome">
                <div class="close cursor_1" @click.stop="close"><i class="el-icon-close" style="font-size: 200%;font-weight: bold;"></i></div>
                <img src="@/assets/image/home/welcome.png" width="1026" height="630" />
                <div class="welcome_ty">
                    <div class="btn-primary ljty" @click.stop="confirmSelect">立即体验</div>
                </div>

            </div>

        </div>
    </transition>
</template>

<script>
import api from '@/api/api';
import data from '@/assets/data';
export default {
    props: {
        title: {
            type: String,
            default: '提醒'
        },
        text: {
            type: String,
            default: ''
        },
        confirmText: {
            type: String,
            default: '确认'
        }
    },
    data() {
        return {
            isVisible: false
        };
    },
    methods: {
        openPrompt(i) {
            this.isVisible = true;
        },
        close() {
            this.isVisible = false;
        },
        confirmSelect() {
            // 处理确认逻辑
            this.isVisible = false;
            localStorage.setItem(this.welcome, true)
            // this.$emit('confirm')
        },

    }
};
</script>

<style scoped>
#del_popup {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(14, 14, 14, 0.2);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;
}


.close{
    position: absolute;
    right: 13px;
    top: 15px;
}
.welcome {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.welcome_ty {
    position: absolute;
    bottom: 20px;
}

.ljty {
    width: 342px;
    height: 62px;
    background: radial-gradient(circle, #1685FD, #016BF8);
    border-radius: 31px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    font-size: 18px;
    color: #FFFFFF;
}

/* 淡入淡出动画 */
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}
@media screen and (max-height:641px) {
    .welcome{
        zoom: 0.6;
    }
}
</style>